/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most browsers block audio from playing until you've interacted with the page — pressing Start counts as that interaction, so the alarm should work. If it's still silent, check that the tab and your device aren't muted, since a muted tab icon silences the alarm along with everything else.`)
};

const es_timer_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mayoría de los navegadores bloquean el audio hasta que has interactuado con la página — presionar Iniciar cuenta como esa interacción, así que la alarma debería funcionar. Si sigue en silencio, comprueba que la pestaña y tu dispositivo no estén silenciados, ya que un icono de pestaña silenciado apaga la alarma junto con todo lo demás.`)
};

const de_timer_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die meisten Browser blockieren Audiowiedergabe, bis du mit der Seite interagiert hast — das Drücken von Start zählt als diese Interaktion, der Alarm sollte also funktionieren. Bleibt es trotzdem still, prüfe, ob Tab und Gerät nicht stummgeschaltet sind, denn ein stummgeschalteter Tab schaltet auch den Alarm stumm.`)
};

const nl_timer_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De meeste browsers blokkeren audio totdat je interactie hebt gehad met de pagina — op Start drukken telt als die interactie, dus het alarm zou moeten werken. Als het nog steeds stil blijft, controleer dan of het tabblad en je apparaat niet gedempt staan, want een gedempt tabblad-icoon zet het alarm net als al het andere geluid uit.`)
};

const fr_timer_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La plupart des navigateurs bloquent la lecture audio tant que vous n’avez pas interagi avec la page — appuyer sur Démarrer compte comme cette interaction, donc l’alarme devrait fonctionner. Si elle reste silencieuse, vérifiez que l’onglet et votre appareil ne sont pas en sourdine, car une icône d’onglet en sourdine coupe l’alarme comme tout le reste.`)
};

const it_timer_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La maggior parte dei browser blocca la riproduzione audio finché non interagisci con la pagina — premere Avvia conta come quell'interazione, quindi l'allarme dovrebbe funzionare. Se resta silenzioso, controlla che la scheda e il dispositivo non siano silenziati, poiché un'icona di scheda silenziata blocca l'allarme insieme a tutto il resto.`)
};

const pt_br2_timer_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A maioria dos navegadores bloqueia a reprodução de áudio até que você interaja com a página — pressionar Iniciar conta como essa interação, então o alarme deveria funcionar. Se ainda assim ficar em silêncio, verifique se a aba e seu dispositivo não estão no mudo, já que um ícone de aba silenciada bloqueia o alarme junto com tudo o mais.`)
};

const pt_timer_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A maioria dos navegadores bloqueia a reprodução de áudio até interagir com a página — premir Iniciar conta como essa interação, por isso o alarme deve funcionar. Se continuar em silêncio, verifique se o separador e o seu dispositivo não estão em silêncio, já que um ícone de separador silenciado silencia o alarme juntamente com tudo o resto.`)
};

const ja_timer_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多くのブラウザは、ページを操作するまで音声の再生をブロックします。スタートを押すことがその操作に当たるため、通常アラームは鳴るはずです。それでも鳴らない場合は、タブやデバイスがミュートになっていないか確認してください。タブがミュート状態だと、アラームを含めてすべての音が消音されます。`)
};

const zh_timer_hub_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大多数浏览器会阻止音频播放，直到你与页面进行过交互 — 点击开始就算作一次交互，因此闹铃应该能正常响起。如果仍然没有声音，请检查标签页和设备是否处于静音状态，因为静音的标签页图标会连同闹铃一起被静音。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_hub_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_hub_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_hub_faq4_a", locale)
	if (locale === "en") return en_timer_hub_faq4_a(inputs)
	if (locale === "es") return es_timer_hub_faq4_a(inputs)
	if (locale === "de") return de_timer_hub_faq4_a(inputs)
	if (locale === "nl") return nl_timer_hub_faq4_a(inputs)
	if (locale === "fr") return fr_timer_hub_faq4_a(inputs)
	if (locale === "it") return it_timer_hub_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_hub_faq4_a(inputs)
	if (locale === "pt") return pt_timer_hub_faq4_a(inputs)
	if (locale === "ja") return ja_timer_hub_faq4_a(inputs)
	return zh_timer_hub_faq4_a(inputs)
};